import { createFrontierBlock } from '../createFrontierBlock.js';

var config = {
  remoteModule: 'buyability-sub-app/CMSBuyAbility',
  title: 'BuyAbility',
  description: 'BuyAbility block for displaying purchase options',
  icon: 'money-alt',
  category: 'more',
  editorPlaceholder: 'Placeholder for BuyAbility'
};
var index = createFrontierBlock('cms-frontier/buyability', config);

export { index as default };
